import { Link } from 'react-router-dom';

import { ROUTES } from '@/app/router/route-constants';
import { Button } from '@/shared/components/button';
import { useDocumentTitle } from '@/shared/hooks/use-document-title';

export function UnauthorizedPage() {
  useDocumentTitle('Unauthorized');

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-content-bg px-4 text-center">
      <div className="bg-warning/15 mb-4 flex h-16 w-16 items-center justify-center rounded-full">
        <svg
          className="h-8 w-8 text-warning"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"
          />
        </svg>
      </div>
      <h1 className="text-2xl font-bold text-body">Access Denied</h1>
      <p className="mt-2 max-w-md text-sm text-secondary">
        You don&apos;t have permission to access this resource. Contact your
        administrator if you believe this is an error.
      </p>
      <Link to={ROUTES.DASHBOARD} className="mt-6">
        <Button>Back to Dashboard</Button>
      </Link>
    </div>
  );
}
